import httpClient from "./httpClient";

export default {
  async getNotes(args) {
    const response = await httpClient.get(
      `/notes/${args.entityType}/${args.entityId}`
    );
    return response.data;
  },

  async saveNote(args) {
    const response = await httpClient.post(
      `/notes/${args.entityType}/${args.entityId}`,
      {
        ...args
      }
    );
    return response.data;
  },

  async deleteNote(args) {
    const response = await httpClient.delete(`/notes/${args.id}`);
    return response.data;
  }
};
